import { render, staticRenderFns } from "./MenuChild.vue?vue&type=template&id=1900178e&scoped=true&"
import script from "./MenuChild.vue?vue&type=script&lang=js&"
export * from "./MenuChild.vue?vue&type=script&lang=js&"
import style0 from "./MenuChild.vue?vue&type=style&index=0&id=1900178e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1900178e",
  null
  
)

export default component.exports